import { useSelector, useDispatch } from 'react-redux';
import {
  setSurveyData,
  setCurrentFormId,
  saveFormResponse,
  updateFormResponse,
  clearFormResponse,
  clearAllSurveyData,
  selectSurveyData,
  selectCurrentFormId,
  selectFormResponses,
  selectFormResponseById,
} from '../slices/surveySlice';

/**
 * Custom hook for managing survey data in Redux store
 * @returns {Object} - Survey state and actions
 */
export const useSurvey = () => {
  const dispatch = useDispatch();
  const surveyData = useSelector(selectSurveyData);
  const currentFormId = useSelector(selectCurrentFormId);
  const formResponses = useSelector(selectFormResponses);

  // Get responses for a specific form
  const getFormResponse = (formId) => {
    return formResponses[formId] || {};
  };

  // Set survey data
  const updateSurveyData = (data) => {
    dispatch(setSurveyData(data));
  };

  // Set current form ID
  const updateCurrentFormId = (formId) => {
    dispatch(setCurrentFormId(formId));
  };

  // Save complete form response
  const submitFormResponse = (formId, responses) => {
    dispatch(saveFormResponse({ formId, responses }));
  };

  // Update a specific field in a form response
  const updateResponse = (formId, fieldKey, value) => {
    dispatch(updateFormResponse({ formId, fieldKey, value }));
  };

  // Clear responses for a specific form
  const resetFormResponse = (formId) => {
    dispatch(clearFormResponse(formId));
  };

  // Clear all survey data
  const resetAllSurveyData = () => {
    dispatch(clearAllSurveyData());
  };

  return {
    surveyData,
    currentFormId,
    formResponses,
    getFormResponse,
    updateSurveyData,
    updateCurrentFormId,
    submitFormResponse,
    updateResponse,
    resetFormResponse,
    resetAllSurveyData,
  };
};

export default useSurvey;
